import React from 'react'
import hero_image from '../../../assets/images/BannerSmall.jpg'
import { config } from '../config'
import { Link } from 'react-router-dom'
const HeroSection = () => {
    return (
        <section className='py-5 position-relative overflow-hidden mb-md-0 mb-5'>
            <div className="auto-container py-4 ">
                <div className="row justify-content-between align-items-center">
                    <div className="col-md-5 d-md-block d-none">
                        <div data-aos="fade-right">
                            <figure className="hero_image">
                                <img src={hero_image} alt="" /></figure>
                        </div>
                    </div>
                    <div className="col-md-6" data-aos="fade-up">
                        <div className="content-box" >
                            <div className='fw-semibold text-white rounded-3 d-inline-block hero_badge'>
                                Precision Driving – Best Driving School</div>
                            <h1 className='display-5 fw-semibold mb-3 text-white'>
                                Looking to get on the road
                                <span className='text-green '> with confidence </span>  and master the art of driving?</h1>
                            <p className='text-white'>Pass Your Test, Drive Safely, and Gain the Skills for a Lifetime</p>
                        </div>

                        {/* <div className='pt-2 pe-md-5'>
                            <div className='d-flex justify-content-between align-items-center hero_searchbar mt-4' >
                                <input type="text" placeholder='Find a Instructor using postal code' />
                                <button><i className='bi bi-search me-md-2'></i><span className='d-md-inline d-none'>Search</span></button>
                            </div>
                        </div> */}

                        <div className="btn-box mt-4 d-md-none d-inline-block">
                            <Link to={`${config.appUrl}book-a-lesson`} className="theme-btn btn-one text-white">Enroll Now</Link>
                        </div>

                        <div className='d-md-flex mt-4 hero_lines ms-md-2'>
                            <p>20 years of experience.</p>
                            <span className='px-2 d-md-inline d-none text-green'>|</span>
                            <p>99% of customers would recommend us.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='hero_bg_image'></div>
        </section>
    )
}

export default HeroSection